import type { ListingType } from '@bb/domain/dist/types';

const formatPrice = (price: number, listingType: ListingType) => {
  let fractionDigit = 0;
  if (listingType === 'commercial' && price < 1000) {
    fractionDigit = 2;
  }

  return price?.toLocaleString('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: fractionDigit,
  });
};

export default formatPrice;
